import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import Login from "./containers/Login";
import Homepage from "./containers/Homepage";
import InvitedProjects from "./containers/InvitedProjects";
import InvitedAlternative from "./containers/InvitedAlternative";
import InvitedCriteria from "./containers/InvitedCriteria.js";
import InvitedWeight from "./containers/InvitedWeight.js";
import InvitedEvaluation from "./containers/InvitedEvaluation.js";
import InvitedMAMCAResult from "./containers/InvitedMAMCAResult.js";
import SharedProjects from "./containers/SharedProjects";
import ManageInvitations from "./containers/ManageInvitations"
import ManageSharedProjects from "./containers/ManageSharedProjects"
import InvitedSignup from "./containers/InvitedSignup";
import Signup from "./containers/Signup";
import SignupFree from "./containers/SignupFree";
import Alternative from './containers/Alternative'
import MAMCAActors from './containers/MAMCAActors'
import MAMCACriteria from './containers/MAMCACriteria'
import MAMCAWeight from './containers/MAMCAWeight'
import MAMCAEvaluation from './containers/MAMCAEvaluation'
import MAMCAResult from './containers/MAMCAResult'
import MCACriteria from './containers/MCACriteria'
import MCAWeight from './containers/MCAWeight'
import MCAEvaluation from './containers/MCAEvaluation'
import MCAResult from './containers/MCAResult'
import Results from './containers/Results'
import MAMCASurveySetting from './containers/MAMCASurveySetting'
import MAMCASurveyReceived from './containers/MAMCASurveyReceived'
import MAMCASurveyResult from './containers/MAMCASurveyResult'
import MAMCASurvey from './containers/MAMCASurvey'
import MAMCAWeightSurvey from './containers/MAMCAWeightSurvey'
import MAMCAEvaluationSurvey from "./containers/MAMCAEvaluationSurvey";
import Profile from './containers/Profile'
import LicenseInfo from './containers/LicenseInfo'
import Guide from './containers/Guide'
import GuideBasic from './containers/GuideBasic'
import GuideMCA from './containers/GuideMCA'
import GuideMAMCA from './containers/GuideMAMCA'
import GuideSurvey from './containers/GuideSurvey'
import Admin from './containers/Admin'
import AdminHome from './containers/AdminHome'
import NotFound from "./containers/NotFound";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Cookie from 'js-cookie';


export default ({ childProps }) =>
  <Switch>
    {/* Change the root page */}
    {Cookie.get("isAuthenticated") ?
      <AuthenticatedRoute path="/" exact component={Homepage} props={childProps} /> :
      <UnauthenticatedRoute path="/" exact component={Home} props={childProps} />
    }
    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <AuthenticatedRoute path="/homepage" exact component={Homepage} props={childProps} />
    <AuthenticatedRoute path="/invitedprojects" exact component={InvitedProjects} props={childProps} />
    <AuthenticatedRoute path="/invitedalternative/:projectid/:actorid" exact component={InvitedAlternative} props={childProps} />
    <AuthenticatedRoute path="/invitedcriteria/:projectid/:actorid" exact component={InvitedCriteria} props={childProps} />
    <AuthenticatedRoute path="/invitedweight/:projectid/:actorid" exact component={InvitedWeight} props={childProps} />
    <AuthenticatedRoute path="/invitedevaluation/:projectid/:actorid" exact component={InvitedEvaluation} props={childProps} />
    <AuthenticatedRoute path="/invitedmamcaresult/:projectid/:actorid" exact component={InvitedMAMCAResult} props={childProps} />
    <AuthenticatedRoute path="/manageinvitations" exact component={ManageInvitations} props={childProps} />
    <AuthenticatedRoute path="/managesharedprojects" exact component={ManageSharedProjects} props={childProps} />
    <AuthenticatedRoute path="/sharedProjects" exact component={SharedProjects} props={childProps} />
    <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
    <UnauthenticatedRoute path="/signupfree" exact component={SignupFree} props={childProps} />
    <UnauthenticatedRoute path="/invitedsignup/:projectid/:actorid/:email" exact component={InvitedSignup} props={childProps} />
    <AuthenticatedRoute path="/alternative/:projectid" exact component={Alternative} props={childProps} />
    <AuthenticatedRoute path="/mamcaactors/:projectid" exact component={MAMCAActors} props={childProps} />
    <AuthenticatedRoute path="/mamcasurveysetting/:projectid" exact component={MAMCASurveySetting} props={childProps} />
    <AuthenticatedRoute path="/mamcasurveyresult/:projectid/:actorid" exact component={MAMCASurveyResult} props={childProps} />
    <AuthenticatedRoute path="/mamcacriteria/:projectid" exact component={MAMCACriteria} props={childProps} />
    <AuthenticatedRoute path="/mamcaweight/:projectid" exact component={MAMCAWeight} props={childProps} />
    <AuthenticatedRoute path="/mamcaevaluation/:projectid" exact component={MAMCAEvaluation} props={childProps} />
    <AuthenticatedRoute path="/mamcaresult/:projectid" exact component={MAMCAResult} props={childProps} />
    <AuthenticatedRoute path="/mcacriteria/:projectid" exact component={MCACriteria} props={childProps} />
    <AuthenticatedRoute path="/mcaweight/:projectid" exact component={MCAWeight} props={childProps} />
    <AuthenticatedRoute path="/mcaevaluation/:projectid" exact component={MCAEvaluation} props={childProps} />
    <AuthenticatedRoute path="/mcaresult/:projectid" exact component={MCAResult} props={childProps} />
    <AuthenticatedRoute path="/result" exact component={Results} props={childProps} />
    <AuthenticatedRoute path="/mamcasurveysetting/:projectid" exact component={MAMCASurveySetting} props={childProps} />
    <AuthenticatedRoute path="/mamcasurveyreceived/:projectid/:actorid" exact component={MAMCASurveyReceived} props={childProps} />
    <UnauthenticatedRoute path="/mamcasurvey/:projectid/:actorid" exact component={MAMCASurvey} props={childProps} />
    <UnauthenticatedRoute path="/mamcaweightsurvey/:projectid/:actorid" exact component={MAMCAWeightSurvey} props={childProps} />
    <UnauthenticatedRoute path="/mamcaevaluationsurvey/:projectid/:actorid" exact component={MAMCAEvaluationSurvey} props={childProps} />
    <AuthenticatedRoute path="/guide" exact component={Guide} props={childProps} />
    <AuthenticatedRoute path="/guide/basic" exact component={GuideBasic} props={childProps} />
    <AuthenticatedRoute path="/guide/mca" exact component={GuideMCA} props={childProps} />
    <AuthenticatedRoute path="/guide/mamca" exact component={GuideMAMCA} props={childProps} />
    <AuthenticatedRoute path="/guide/survey" exact component={GuideSurvey} props={childProps} />
    <AuthenticatedRoute path="/profile" exact component={Profile} props={childProps} />
    <UnauthenticatedRoute path="/licenseinfo" exact component={LicenseInfo} props={childProps} />
    <UnauthenticatedRoute path="/admin" exact component={Admin} props={childProps} />
    <UnauthenticatedRoute path="/adminhome" exact component={AdminHome} props={childProps} />
    { /* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>;
